import { getConfig } from '@/app/config'

/**
 * A function to construct a URL based on APP_BASE_URL from the configuration.
 * Useful for handling temporary deployments.
 * If baseUrl is empty (undefined or ''), it simply returns a path starting with a slash.
 *
 * @param {string} path - The path (for example, '/settings' or 'reset-password')
 * @returns {string} A properly constructed full path
 */
export function buildUrl(path = '') {
  // Retrieve baseUrl from the configuration
  const baseUrl = getConfig().APP_BASE_URL ?? ''

  // Remove the trailing slash so there are no duplicate slashes
  const trimmedBaseUrl = baseUrl.replace(/\/$/, '')

  // Remove leading slashes from the path to avoid double slashes
  const trimmedPath = path.replace(/^\/+/, '')

  // If baseUrl exists, merge it with the path
  // Otherwise, use '/', appending trimmedPath as needed
  return trimmedBaseUrl ? `${trimmedBaseUrl}/${trimmedPath}` : `/${trimmedPath}`
}
